/**
 * M365 accounts permitted to open the Bills & Subscriptions module at all.
 * Unlike historicalImportAllowlist (which only gates one button), this list
 * gates the entire module — its contents (account numbers, balances, payment
 * methods) are confidential and meant for the owner, HR, and Accounting only.
 */
export const BILLS_REGISTRY_ALLOWED_USERS: string[] = [
  "mikko@intalgarmentsopc.onmicrosoft.com",
  "hrandpurchasing@intalgarmentsopc.onmicrosoft.com",
  "finance1@intalgarmentsopc.onmicrosoft.com",
  "managingowner@intalgarmentsopc.onmicrosoft.com",
];
